import React from 'react';
import { compose } from 'ramda';

import { RichText, Button } from '@synergycms_core/components/generic/';
import Price from '@synergycms_core/components/generic/Price'
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './WebAdvantageWidget.js';
import { CSSTransition } from 'react-transition-group';

class WebAdvantageWidget extends React.Component {
    static displayName = 'WebAdvantageWidget';

    constructor(props) {
        super(props);
        this.state = {
            modalAdvantagesBlock: false
        };
    };

    toggleModalAdvantages = e => {
        e.preventDefault();
        this.setState(state => ({
            modalAdvantagesBlock: !state.modalAdvantagesBlock
        }));
    };

    render() {
        const { theme } = this.props;
        const { classes } = theme.styles;
        const { webAdvantages, price } = this.props.config;

        return (
            <div className={classes.defaultStyle}>
                <div className={classes.webAdvantagesContainer}>
                    <CSSTransition
                        in={!this.state.modalAdvantagesBlock}
                        timeout={300000}
                        mountOnEnter
                        unmountOnExit
                        classNames={{
                            enter: classes.buttonEnter,
                            enterActive: classes.buttonEnterActive,
                            exit: classes.buttonLeave,
                            exitActive: classes.buttonLeaveActive
                        }}>
                        <Button
                            onClick={this.toggleModalAdvantages}
                            richText={{
                                text: '_%ventajas exclusivas web%_',
                                ucFirst: true,
                                innerStyle: ['roboto13Black', 'bold', classes.webAdvantagesHeaderText],
                                rightIcon: {
                                    unicodeContent: this.state.modalAdvantagesBlock ? 'e001' : 'e02e',
                                    innerStyle: [classes.buttonArrow, 'marginLeft5']
                                },
                                icon: {
                                    unicodeContent: 'e0dd',
                                    innerStyle: [classes.buttonIcon]
                                },
                                translate: true
                            }}
                            innerStyle={classes.webAdvantagesButton}
                        />
                    </CSSTransition>
                    <CSSTransition
                        in={this.state.modalAdvantagesBlock}
                        timeout={300}
                        mountOnEnter
                        unmountOnExit
                        classNames={{
                            enter: classes.dropDownEnter,
                            enterActive: classes.dropDownEnterActive,
                            exit: classes.dropDownLeave,
                            exitActive: classes.dropDownLeaveActive
                        }}>
                        <div className={classes.animationContainer}>
                            <Button
                                onClick={this.toggleModalAdvantages}
                                richText={{
                                    text: '_%ventajas exclusivas web%_',
                                    ucFirst: true,
                                    innerStyle: ['roboto13Black', 'bold', classes.webAdvantagesHeaderText],
                                    rightIcon: {
                                        unicodeContent: this.state.modalAdvantagesBlock ? 'e001' : 'e02e',
                                        innerStyle: [classes.buttonArrow, 'marginLeft5']
                                    },
                                    icon: {
                                        unicodeContent: 'e0dd',
                                        innerStyle: [classes.buttonIcon]
                                    },
                                    translate: true
                                }}
                                innerStyle={classes.webAdvantagesButton}
                            />
                            <div className={classes.webAdvantagesBody}>
                                <div className={classes.webAdvantagesPrice}>
                                    <RichText translate={true} ucFirst={true} text={'_%desde%_'} innerStyle={['roboto16Black', 'bold', classes.webAdvantagesSince]} />
                                    <Price innerStyle={classes.priceStyle} amount={price} />
                                </div>
                                <ul className={classes.webAdvantagesListContainer}>
                                    {webAdvantages.map((item, idx) => (
                                        <li key={item.get('id')} className={classes.webAdvantagesRoomList}>
                                            <RichText text={item.get('name')} />
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </CSSTransition>
                </div>
            </div>
        );
    }
};

export default compose(
    PropertyManager(['price', 'webAdvantages']),
    withThemeJSS({ styleFile, link: true })
)(WebAdvantageWidget);